namespace JupitersChoice {
    export class DoBaseGameFinalLightningStrikeOnReelsCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('GameConfig') _gameConfig: Sapphire.GameConfig;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('ResponseHelper') _responseHelper: ResponseHelper;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;
        @inject('OrientationModel') _orientationModel: Sapphire.OrientationModel;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const grids = this._gameConfig.get('external', 'grids');
            const reelsetType = grids[response.grid].reels;
            const reels = this._componentManager.get('Reels');
            const lockedReels = this._responseHelper.getLockedReels(response.lockedWithPreviousReel);

            let lastLockedReel = lockedReels[lockedReels.length - 1];

            if(this._orientationModel.isPortrait){
                let blt2 = this._componentManager.get(`PortraitBolt${lastLockedReel}`);

                blt2.reset();
                blt2.setOnComplete(() => { blt2.hide(); });
                blt2.play();
            }
            
            let blt = this._componentManager.get(`ReelLightning${lastLockedReel}`);

            blt.reset();
            blt.setOnComplete(() => { blt.hide(); });
            blt.play();


            lockedReels.forEach((lockedReel) => {
                reels.updateStrips([lockedReel], reelsetType[response.rawReelIndices[lockedReel]], true);
            });

            this._componentManager.get(`ReelCrumble${lastLockedReel}`).play();
        }
    }
}